<template>

    <ion-toolbar style="padding-top:20px; padding-bottom:20px; display: contents;">

        <ion-item lines="none">
            <ion-label><a @click="$router.push('/home')">Home</a></ion-label>
            <ion-label><a @click="$router.push('/careers')">Careers</a></ion-label>
            <ion-label><ion-select label="Divisions" v-model="select" @ion-change="divselector"
                    style="width: 150px;  --background: transparent; --color: #99aab5;">
                    <ion-select-option value="26">26 Electrical Systems</ion-select-option>
                    <ion-select-option value="27">27 Communication Systems</ion-select-option>
                    <ion-select-option value="28">28 Security Systems</ion-select-option>
                </ion-select></ion-label>
            <ion-label><a @click="$router.push('/contact')">Contact</a></ion-label>
            <ion-label><a @click="$router.push('/projects')">Projects</a></ion-label>

        </ion-item>
        <ion-item style="color:#99aab5" lines="none">
            <p><a href="https://maps.app.goo.gl/9GpMsaVAmAYSKy5Z7" style="color:#99aab5; text-decoration: none;">1451
                    Clearmont St NE, Palm Bay, FL
                    32905</a><br>(321)-271-9197</p>
        </ion-item>

        <div slot="end" style="padding-right: 4vw;">
            <ion-title>Atlantis Electrical Systems</ion-title>
            <p style="color:#99aab5; padding-right:20px;">©️{{ new Date().getFullYear() }} All Rights Reserved.</p>

            <ion-label style="cursor: pointer;"><a @click="$router.push('/terms')">Terms Of Service</a></ion-label>
            <ion-label style="cursor: pointer;"><a @click="$router.push('/policy')">Privacy Policy</a></ion-label>
            <ion-label style="cursor: pointer;"><a @click="$router.push('/cookies')">Cookie Policy</a></ion-label>

        </div>
    </ion-toolbar>

</template>
<script setup lang="ts">

import { computed, ref } from "vue";
import {
    IonPage,
    IonIcon,
    IonHeader,
    IonFooter,
    IonToolbar,
    IonButtons,
    IonSelectOption,
    IonMenuButton,
    IonButton,
    IonContent,
    IonList,
    IonItem,
    IonLabel,
    IonGrid,
    IonTitle,
    IonRow,
    IonCol,
    IonInput,
    IonToast,
    IonSelect,
    IonRadioGroup,
    IonRadio
} from "@ionic/vue";
var select = ref("")
function divselector() {
    if (select.value) {
        router.push("/div" + select.value)
    }
}

</script>
<style>
ion-label a {
    color: white;
    text-decoration: none;
    padding-right: 20px;
}
</style>
<script lang="ts">
import * as outlines from 'ionicons/icons';
import router from "@/router";

export default {
    name: 'Footer',
}
</script>